import { PIE_PALETTE } from "./dashboard.config";

const getPercent = (data, targetName) => {
	const total = data.reduce((s, d) => s + d.value, 0);
	const target = data.find(d => d.key === targetName)?.value ?? 0;
	return Math.round((target / total) * 100);
};

// 只能用字串模板，請勿用ReactComponent，回傳直只接受String型別
const tooltipFormatter = ({ name, value, percent }) => {
	return `
		<strong>${name}</strong><br/>
		${value} 人（${Math.round(percent)}%）
	`;
};

/** ----------圓餅圖專用---------- */
const adaptPie = (raw, config) => {
	// raw: { xAxis: string[], data: string[] }
	const { xAxis, data: values } = raw;
	const data = xAxis.flat(1).map((name, i) => ({
		name,
		value: Number(values[i]),
		itemStyle: { color: PIE_PALETTE[i] },
	}));

	const assigned = config ? assignLevel(data, config) : data;
	const total = assigned.reduce((sum, d) => sum + d.value, 0);
	const first = assigned[0];
	const centerValueText = first ? Math.round((first.value / total) * 100) : 0;

	return {
		data: assigned.map(({ name, value, color, message, itemStyle }) => ({
			name,
			value,
			...(message && { message }),
			itemStyle: color ? { color } : itemStyle,
		})),
		centerValueText,
	};
};

const assignLevel = (data, config) => {
	const sorted = [...data].sort((a, b) => a.value - b.value);
	return sorted.map((item, i) => ({
		...item,
		...config[i],
	}));
};

/** ----------直線圖專用---------- */
const adaptBar = raw => {
    // raw: { xAxis: string[], data: string[] }
    const { xAxis, data: values } = raw;
    const axisLabels = xAxis;
    const data = values.flat(1).map(v => Number(v));;
    const avg = Math.round(data.reduce((sum, v) => sum + v, 0) / data.length);
    return { axisLabels, data, avg };
};

export { getPercent, tooltipFormatter, adaptPie, adaptBar };
